var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"aui-card--fill",attrs:{"shadow":"never"}},[_c('router-link',{staticStyle:{"font-size":"18px","color":"blue"},attrs:{"to":"/erp-store-log-manager"}},[_vm._v("该功能已下线,请使用\"库存管理-库存记录\",点击跳转")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }